import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-v2/utils/nav-context';

const RunOverviewPage = lazy(() => import('~/features/catalog-v2/pages/run-overview-page'));

/** `?stage=` deep-links the stepper (P0) into the overview's stages table, opening that row.
 *  `?fStage=` deep-links the mix Summary's selected stage pane (docs/run-summary-funnel.md §4) —
 *  kept distinct from `stage` so the two deep links (today's progress-card fallback and the mix)
 *  never collide. `from`/`back` (S12) — the failure-patterns view links batches straight to this tab. */
const searchSchema = z.object({
  stage: z.string().optional(),
  fStage: z.string().optional(),
  ...navContextSearchSchema,
});

export const Route = createFileRoute('/_authenticated/_tenant/catalog-v2/runs/$runId/')({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId } = Route.useParams();
  const { stage, fStage } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunOverviewPage
        runId={runId}
        expandStage={stage ?? null}
        selectedStage={fStage ?? null}
        onSelectedStageChange={(next) => {
          void navigate({
            search: (prev) => ({
              ...prev,
              fStage: next ?? undefined,
            }),
            replace: true,
          });
        }}
      />
    </Suspense>
  );
}
